import { z } from 'zod';

export const PENAL_NULLITIES_FAMILY_IDS = [
  'enquete_competence_saisine',
  'controle_identite_interpellation',
  'garde_a_vue_audition_libre',
  'perquisition_saisie_scelles',
  'techniques_speciales_enquete',
  'instruction',
  'detention_mesures_surete',
  'saisine_jugement',
  'prescription_action_publique',
  'action_civile',
] as const;

export const PenalNullitiesFamilyIdSchema = z.enum(PENAL_NULLITIES_FAMILY_IDS);
export type PenalNullitiesFamilyId = z.infer<typeof PenalNullitiesFamilyIdSchema>;

export const RetryFailedNullitiesFamilyRequestSchema = z.object({
  family_id: PenalNullitiesFamilyIdSchema,
}).strict();
export type RetryFailedNullitiesFamilyRequest = z.infer<
  typeof RetryFailedNullitiesFamilyRequestSchema
>;

export const RetryFailedNullitiesFamilyResponseSchema = z.object({
  family_id: PenalNullitiesFamilyIdSchema,
  document_id: z.string().uuid(),
  version: z.number().int().positive(),
  analysis_completeness: z.enum(['complete', 'partial']),
  publication_reused: z.boolean(),
}).strict();
export type RetryFailedNullitiesFamilyResponse = z.infer<
  typeof RetryFailedNullitiesFamilyResponseSchema
>;

/** Backend-owned pointer to the exact Review phase that produced a V2 document. */
export const NullitiesRetryLineageSchema = z.object({
  pipeline_run_id: z.string().uuid(),
  phase_id: z.string().uuid(),
  protocol_pack_id: z.string().trim().min(1).max(120),
  protocol_pack_version: z.number().int().positive(),
  activation_plan_fingerprint: z.string().regex(/^[a-f0-9]{64}$/),
}).strict();
export type NullitiesRetryLineage = z.infer<typeof NullitiesRetryLineageSchema>;

/** Present only on a document created by a targeted family retry. */
export const NullitiesRetryAttemptMetadataSchema = z.object({
  source_document_id: z.string().uuid(),
  source_document_version: z.number().int().positive(),
  family_id: PenalNullitiesFamilyIdSchema,
}).strict();
export type NullitiesRetryAttemptMetadata = z.infer<
  typeof NullitiesRetryAttemptMetadataSchema
>;
